export default __webpack_public_path__ + "static/media/21.94ca8827.webp";